export interface HolderAvatarNamePartsInput {
  display_name?: string;
  first_name?: string;
  last_name?: string;
}

export interface HolderAvatarNameParts {
  firstName: string;
  lastName: string;
}

export const buildHolderAvatarNameParts = (
  holder: HolderAvatarNamePartsInput,
): HolderAvatarNameParts => {
  const displayName = holder.display_name || '-';
  const holderFirstName = holder.first_name?.trim() || '';
  const holderLastName = holder.last_name?.trim() || '';

  let firstName = '';
  let lastName = '';

  if (holderFirstName || holderLastName) {
    firstName = holderFirstName
      ? holderFirstName[0]?.toUpperCase() || ''
      : holderLastName[0]?.toUpperCase() || '';
    lastName = holderFirstName && holderLastName ? holderLastName[0]?.toUpperCase() || '' : '';
  } else {
    const words = (displayName || '')
      .trim()
      .split(/\s+/)
      .filter(Boolean);

    firstName = words[0]?.[0]?.toUpperCase() || '?';
    lastName = words[1]?.[0]?.toUpperCase() || '';
  }

  return {
    firstName,
    lastName,
  };
};
